import {
  DsButton,
  DsCard,
  DsDialog,
  DsExplorerLink,
  DsLoader,
  DsTag,
} from '@tokenyico/design-system/dist/reactJS';
import { signMessage, disconnect } from '@wagmi/core';
import { useWeb3Modal } from '@web3modal/wagmi/dist/esm/exports/react';
import { formActions } from 'app/state/actions';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'redux-zero/react';
import { OnchainIdService } from 'services';
import { useAccount } from 'wagmi';

const UserManaged = ({ unverifiedWallet, onVerified, setError, selectedToken }) => {
  const network = selectedToken.blockchainNetwork;
  const { t } = useTranslation();
  const [isWrongWallet, setIsWrongWallet] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { open, close } = useWeb3Modal();

  const ref = useRef();
  useEffect(() => {
    ref.current.open();
  }, []);

  const { address, isConnected } = useAccount({
    onConnect() {
      sign();
    },
  });
  const connectWallet = async () => {
    if (!isConnected || !address) {
      open();
      return;
    }
    sign();
  };

  const sign = async () => {
    if (address.toLowerCase() !== unverifiedWallet.walletAddress.toLowerCase()) {
      setIsWrongWallet(true);
      disconnect();
      return;
    } else {
      setIsWrongWallet(false);
    }

    const signature = await signMessage({
      message: `Proof of ownership: I here by declare I am the owner of the wallet: ${unverifiedWallet.walletAddress}.`,
    });
    close();

    setIsSubmitting(true);
    try {
      await OnchainIdService.postWallet({
        walletAddress: address,
        provider: unverifiedWallet.provider,
        alias: unverifiedWallet.alias,
        source: unverifiedWallet.source,
        signature,
      });
      onVerified();
    } catch (e) {
      setError(e);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <DsDialog id="unverifiedWallet" isModal isDismissible={false} ref={ref}>
      <div>
        {!isSubmitting ? (
          <>
            <h1>{t('verifyWallet.userManaged.title')}</h1>
            <p>{t('verifyWallet.userManaged.text')}</p>
            <DsCard shadowDistance="0" padding="4" className="_mtop-3">
              <div>
                <DsTag
                  version="warning"
                  label={t('verifyWallet.userManaged.notVerified')}
                  icon="pending"
                  iconSize="1rem"
                />

                <p className="_mtop-3">{t('shared.walletAddress')}</p>
                <DsExplorerLink
                  isCopyable
                  type="wallet"
                  address={unverifiedWallet.walletAddress}
                  network={network}
                />
                {isWrongWallet && (
                  <p className="error _mtop-3">{t('verifyWallet.userManaged.wrongWallet')}</p>
                )}

                <DsButton
                  className="_mtop-3"
                  isFullWidth
                  isReverse
                  label={t('verifyWallet.userManaged.verifyWallet')}
                  icon="open-to-right"
                  version="success"
                  onClick={connectWallet}
                />
              </div>
            </DsCard>
          </>
        ) : (
          <DsLoader />
        )}
      </div>
    </DsDialog>
  );
};

export default connect((state) => state.holder, formActions)(UserManaged);
